/**
 * Site-wide logo carousel functionality
 */
if ('undefined' != typeof jQuery) jQuery(function($){
    if ( ! $('.logo-carousel__items').length) return;
    $('.logo-carousel__items').cycle({log: false});
});
